import { useEffect } from 'react';
import { useMatches } from 'react-router';

const SITE_TITLE = 'Veevart Backoffice';

/** A route's `handle`, as far as the title machinery cares. */
type TitleHandle = { title?: string };

/**
 * Applies the document title from the deepest matched route's `handle.title`.
 *
 * This is the replacement for Next's `export const metadata`, and it keeps the
 * same two properties: titles are declared by the **route**, not by the feature
 * component, and they compose through the `'%s · Veevart Backoffice'` template
 * that `metadata.title.template` used to apply.
 */
export function useDocumentTitle() {
    const matches = useMatches();

    const title = matches
        .map((match) => (match.handle as TitleHandle | undefined)?.title)
        .filter((value): value is string => Boolean(value))
        .at(-1);

    useEffect(() => {
        document.title = title ? `${title} · ${SITE_TITLE}` : SITE_TITLE;
    }, [title]);
}
